import { Box, Checkbox } from "@mui/material"
import { prevent } from "lib/prevent"
import { getSelectedItemsKey, useSelection, useSelectionReferenceType } from "routes/schedule/lib/useSelection"
import { useTreeItem } from "routes/schedule/lib/useTreeItem"
import { findInChildren } from "library/tree/index.mjs"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useMemo } from "react"
import { useMemoryReference } from "lib/@hooks/use-memory-reference"
import { filterSchedules } from "ioc"
import { IfMultiSelect } from "../lib/if-multi-select"

export function SelectedChildren({ id, depth }) {
    const [isSelected] = useSelection()
    const selectedReferenceType = useSelectionReferenceType()
    const selectedItemsKey = getSelectedItemsKey(selectedReferenceType)
    const [, , save] = useMemoryReference({ [selectedItemsKey]: {} }, selectedReferenceType)
    const { target, isMultiSelect } = useBoundContext()
    const item = useTreeItem(id ?? target.selectedId ?? target.id)
    const allSchedules = useMemo(
        () => findInChildren(item, (c) => !!c._id && c?.type !== "group", depth),
        [depth, item]
    )
    const availableSchedules = filterSchedules(allSchedules)
    const areAllSelected = availableSchedules.length && availableSchedules?.every((c) => isSelected([c._id, c.id]))
    const areSomeSelected = areAllSelected || availableSchedules?.some((c) => isSelected([c._id, c.id]))

    return (
        <IfMultiSelect condition={isMultiSelect}>
            {!!availableSchedules.length && (
                <Box sx={{ lineHeight: 0 }}>
                    <Checkbox
                        data-cy="basket-checkbox"
                        className={`checkbox ${
                            !areAllSelected && areSomeSelected
                                ? "indeterminate"
                                : areAllSelected
                                  ? "checked"
                                  : "not-checked"
                        }`}
                        indeterminate={!areAllSelected && areSomeSelected}
                        checked={!!areAllSelected}
                        onClick={prevent(toggle)}
                    />
                </Box>
            )}
        </IfMultiSelect>
    )

    function toggle() {
        const set = {}
        availableSchedules.forEach((c) => {
            if (areSomeSelected) {
                set[c._id] = false
            } else {
                set[c._id] = c.id ?? true
            }
        })

        save((reference) => ({
            ...reference,
            [selectedItemsKey]: { ...reference[selectedItemsKey], ...set },
        }))
    }
}
